export enum MortgageIncreaseSteps {
  MakeAppointment = 1
}
